import { render, staticRenderFns } from "./UpdateJobOfferSetting.vue?vue&type=template&id=6477f382&"
import script from "./UpdateJobOfferSetting.vue?vue&type=script&lang=js&"
export * from "./UpdateJobOfferSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6477f382')) {
      api.createRecord('6477f382', component.options)
    } else {
      api.reload('6477f382', component.options)
    }
    module.hot.accept("./UpdateJobOfferSetting.vue?vue&type=template&id=6477f382&", function () {
      api.rerender('6477f382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/JobOffers/UpdateJobOfferSetting.vue"
export default component.exports